const pt = {
  // Navbar
  nav_home: "Início",
  nav_about: "Sobre o Tio Tenten",
  nav_services: "Serviços e Preços",
  nav_flow: "Fluxo do Serviço",
  nav_testimonials: "Depoimentos",
  nav_faq: "Perguntas Frequentes",
  nav_contact: "Contato",
  nav_cta: "Reservar Leitura de Nome",
  nav_subtitle: "Leitura de Nome · Okinawa",
  nav_title: "Consultório do Tio Tenten",

  // Hero
  hero_headline1: "Na tranquila",
  hero_headline2: "ilha de Okinawa,",
  hero_headline3: "escutamos",
  hero_headline4: "o som do seu nome.",
  hero_body: "Reservas para leitura de nomes com meses de espera.\nTodo mês visito pessoalmente a ilha de Okinawa\npara transmitir seu nome ao mestre.",
  hero_pill1: "Sem mudança de nome",
  hero_pill2: "100% online",
  hero_pill3: "Entrega em até 1 mês",
  hero_pill4: "100 vagas mensais",
  hero_btn_apply: "Reservar Leitura de Nome",
  hero_btn_services: "Ver Serviços",
  hero_scroll: "Role para baixo",

  // About
  about_heading: "Sobre o Tio Tenten",
  about_intro: "Na tranquila ilha <strong>Ikei</strong>, cercada pelo mar quente de Okinawa,\nvive alguém que adiciona uma pequena luz a cada nome.\nAs pessoas o chamam carinhosamente de <strong>\"Tio Tenten\"</strong>.",
  about_block1_label: "De bancário a leitor de nomes",
  about_block1_text: "O Tio Tenten era originalmente bancário.\nCom dedicação, tornou-se o <strong>gerente de agência mais jovem</strong> da empresa.\nAo conhecer muitas pessoas, surgiu uma dúvida em seu coração.",
  about_block1_quote: "\"Por que algumas pessoas parecem navegar com vento favorável, mesmo com o mesmo esforço?\"",
  about_block1_sub: "Essa pequena dúvida foi o início de uma grande jornada de descoberta.",
  about_block2_label: "Sabedoria antiga e iluminação tranquila",
  about_block2_text: "Dedicou todo o seu tempo livre ao estudo de textos antigos sobre leitura de nomes, explorando cuidadosamente os traços dos kanjis tradicionais e o fluxo fonético.",
  about_block2_text2: "Percebeu que <strong>\"os ten-ten (pontos de sonorização) podem harmonizar suavemente o fluxo de um nome\"</strong>.",
  about_block2_sub: "Não é magia dramática, nem uma fórmula de sucesso espetacular.\nÉ um caminho suave para revelar mais claramente a luz que já existe dentro de você.",
  about_block3_label: "Espalhado pelo boca a boca — agora com 6 meses de espera",
  about_block3_text: "Sua leitura calorosa se espalhou completamente pelo boca a boca, e agora <strong>consultas chegam de todo o país sem parar</strong>.\nTrata todos com o mesmo coração, sejam famosos ou não.\nColoca as mãos em cada nome e acompanha a vida de cada pessoa.\nEssa é a forma do Tio Tenten.",

  // Gallery
  gallery_heading: "Galeria",
  gallery_sub: "Okinawa · Ilha Ikei",

  // Services
  services_heading: "Serviços e Preços",
  services_note1: "※ Todos os planos incluem a taxa de leitura do mestre e nossa taxa de serviço de representação local.",
  services_note2: "※ Sem custos adicionais. Pode confiar com tranquilidade.",
  services_tab1: "Nome Pessoal",
  services_tab2: "Nome Comercial",
  services_tab3: "Nome de Animal",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "Examinamos suavemente seu crescimento, ambiente e movimentos do coração para adicionar os ten-ten mais adequados.",
  services_tab2_desc: "Trazemos uma brisa suave para novos desafios. Harmonizamos tranquilamente o fluxo do negócio.",
  services_tab3_desc: "Para o membro da família que está sempre ao seu lado. Damos um nome cheio de paz e calor.",
  services_row1_target1: "16 anos ou mais",
  services_row1_target2: "4 a 15 anos",
  services_row1_target3: "0 a 3 anos",
  services_row2_target1: "Nome comercial / empresa / loja",
  services_row3_target1: "Nome de animal de estimação",
  services_col_target: "Público-alvo",
  services_col_price: "Preço (com impostos)",
  services_cta: "Reservar este serviço",
  services_includes_title: "O que está incluído (tudo no preço)",
  services_inc1: "Leitura de nome",
  services_inc2: "Sugestão dos ten-ten ideais",
  services_inc3: "Envio de cartão tamanho cartão de visita (grátis, se desejado)",
  services_inc4: "Conselho de boa sorte",
  services_inc5: "Foto digital do cartão de nome",
  services_includes_note: "A leitura tem como objetivo revelar suavemente o charme que já existe no nome.",
  services_payment_title: "Forma de pagamento",
  services_payment_method: "Transferência bancária (pré-pago)",
  services_payment_desc: "Após a inscrição, forneceremos os dados bancários.\nQuando o pagamento for concluído, o fluxo de boa sorte começa a se reunir silenciosamente.",
  services_first_title: "Para quem visita pela primeira vez",
  services_first_desc: "É natural sentir insegurança.\nEssa sensação é um sinal interior,\nde que é hora de começar uma mudança suave.",
  services_first_cta: "Começar com uma consulta",

  // Flow
  flow_heading: "Fluxo do Serviço",
  flow_step1_title: "Envio do formulário",
  flow_step1_c1: "Preencha as informações necessárias no formulário dedicado.",
  flow_step1_c2: "Responderemos em 2 a 3 dias úteis após o envio.",
  flow_step1_c3: "O e-mail incluirá as próximas etapas e instruções de transferência bancária.",
  flow_step2_title: "Transferência da taxa de leitura",
  flow_step2_c1: "Transfira a taxa de leitura para a conta indicada no e-mail de resposta.",
  flow_step2_c2: "Após confirmar o pagamento, começaremos a preparar a leitura em ordem.",
  flow_step3_title: "Notificação de transferência concluída",
  flow_step3_c1: "Após a transferência, envie a foto do comprovante para o endereço indicado no e-mail.",
  flow_step3_c2: "Após a confirmação, enviaremos a mensagem \"Registro concluído\".",
  flow_step3_note: "Sem esta notificação, não podemos iniciar a leitura. Por favor, envie obrigatoriamente.",
  flow_step4_title: "Recebimento do resultado da leitura",
  flow_step4_c1: "Após a conclusão da leitura, enviaremos por e-mail o cartão de nome e a foto dos ten-ten em aproximadamente 1 semana.",
  flow_step4_c2: "Em seguida, enviaremos por e-mail o relatório detalhado de leitura e o conselho de boa sorte.",
  flow_step5_title: "Envio do cartão de nome (opcional)",
  flow_step5_c1: "Se desejar, enviaremos por correio um cartão tamanho cartão de visita escrito pelo próprio mestre.",
  flow_step5_c2: "Por favor, insira o endereço postal correto no campo de endereço do formulário.",
  flow_step5_note: "Se não precisar do cartão, basta inserir apenas a cidade de residência.",
  flow_banner_title: "Tudo online. De qualquer lugar do Japão.",
  flow_banner_desc: "Não é necessário vir pessoalmente à ilha Ikei em Okinawa.\nVocê pode começar imediatamente sem mudar sua rotina diária.",
  flow_banner_cta: "Inscrever-se agora",

  // Testimonials
  testimonials_heading: "Depoimentos",
  testimonials_viewing: "Visualizando",

  // FAQ
  faq_heading: "Perguntas Frequentes",
  faq_cta_title: "Tem outras perguntas?",
  faq_cta_desc: "Qualquer pequena pergunta é bem-vinda.\nPerguntas que você tem vergonha de fazer — são exatamente o que mais queremos ouvir.",
  faq_cta_btn: "Fazer uma pergunta",

  // CTA Banner
  cta_heading1: "Consulta",
  cta_heading2: "Gratuita",
  cta_btn: "Reservar agora",

  // Contact
  contact_heading: "Contato",
  contact_desc: "Envie sua inscrição de leitura ou consulta através deste formulário. Normalmente respondemos em 2 a 3 dias úteis.",
  contact_address_label: "Endereço",
  contact_address_value: "Tochigi, Japão (Online · Atendimento nacional)",
  contact_email_label: "E-mail",
  contact_hours_label: "Horário de atendimento",
  contact_hours_value: "Seg–Sex 9:00–18:00 (Fechado sáb/dom/feriados)",
  contact_note_title: "Sobre as respostas",
  contact_note_desc: "As respostas podem ir para a pasta de spam.\nSe não receber resposta em 2 a 3 dias úteis, entre em contato diretamente por e-mail.",
  contact_field_name: "Nome",
  contact_field_furigana: "Furigana (leitura do nome)",
  contact_field_email: "Endereço de e-mail",
  contact_field_phone: "Número de telefone",
  contact_field_service: "Serviço desejado",
  contact_field_message: "Mensagem",
  contact_placeholder_name: "João Silva",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@mail.com",
  contact_placeholder_phone: "+55 000 0000 0000",
  contact_placeholder_message: "Por favor, insira o nome que deseja ler ou suas perguntas e solicitações.",
  contact_select_placeholder: "Selecione",
  contact_service1: "Nome pessoal",
  contact_service2: "Nome comercial",
  contact_service3: "Nome de animal",
  contact_service4: "Outro / Consulta",
  contact_submit: "Enviar",
  contact_submitting: "Enviando...",
  contact_privacy: "As informações pessoais enviadas pelo formulário serão usadas apenas para o serviço de leitura de nomes.",
  contact_error: "Falha no envio. Tente novamente mais tarde ou entre em contato diretamente por e-mail.",
  contact_err_name: "Por favor, insira seu nome",
  contact_err_email_required: "Por favor, insira seu endereço de e-mail",
  contact_err_email_invalid: "Por favor, insira um endereço de e-mail válido",
  contact_err_service: "Por favor, selecione um serviço",
  contact_err_message_required: "Por favor, insira uma mensagem",
  contact_err_message_limit: "A mensagem deve ter no máximo 500 caracteres",
  contact_thanks_title: "Mensagem enviada",
  contact_thanks_desc: "Obrigado por entrar em contato.\nApós verificar sua mensagem, responderemos em <strong>2 a 3 dias úteis</strong>.\nPor favor, aguarde.",
  contact_thanks_check1: "Verifique seu e-mail de confirmação",
  contact_thanks_check2: "Verifique também a pasta de spam",
  contact_thanks_check3: "Aguarde a resposta em 2 a 3 dias úteis",
  contact_thanks_another: "Enviar outra mensagem",

  // Footer
  footer_subtitle: "Leitura de Nome · Okinawa",
  footer_title: "Consultório do Tio Tenten",
  footer_desc: "De Okinawa para todo o país. Um mestre de leitura de nomes com mais de 50 anos de experiência lê com carinho o destino contido em seu nome.",
  footer_contact_title: "Informações de contato",
  footer_address_label: "Endereço",
  footer_address_value: "Tochigi, Japão\n(Online · Atendimento nacional)",
  footer_email_label: "E-mail",
  footer_hours_label: "Horário de atendimento",
  footer_hours_value: "Seg–Sex 9:00–18:00\n(Fechado sáb/dom/feriados)",
  footer_nav_title: "Navegação",
  footer_copyright: "© 2025 Consultório do Tio Tenten. Todos os direitos reservados.",
  footer_privacy: "Política de Privacidade",
  footer_law: "Lei de Comércio Específico",
  footer_sitemap: "Mapa do Site",
};

export default pt;
